import { api } from './index';
function index(regionId) { const path = `/api/internal/regions/${regionId}/communes`; return api({ method: 'get', url: path }).then(response => { var _response$data; return (_response$data = response.data) == null ? void 0 : _response$data.communes; }); }
export { index };
